'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookingTimeCard = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(BookingTimeCard, _Component);

  function BookingTimeCard() {
    (0, _classCallCheck3.default)(this, BookingTimeCard);
    return (0, _possibleConstructorReturn3.default)(this, (BookingTimeCard.__proto__ || (0, _getPrototypeOf2.default)(BookingTimeCard)).apply(this, arguments));
  }

  (0, _createClass3.default)(BookingTimeCard, [{
    key: 'renderDiscount',
    value: function renderDiscount(percent, discount) {
      if (!percent && !discount) return '';
      return percent > 0 ? ' (-' + percent + '%)' : ' (-' + _support.Helper.shortenDisplayPrice(discount) + ')';
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./BookingTimeCard.scss');
      var _props = this.props,
          _props$data = _props.data,
          _id = _props$data._id,
          selected = _props$data.selected,
          time = _props$data.time,
          percent = _props$data.percent,
          discount = _props$data.discount,
          empty = _props$data.empty,
          shop = _props$data.shop,
          onClick = _props.onClick;

      var freelance = !!(shop && shop.shopType === 'freelance');
      return _react2.default.createElement(
        'div',
        { className: styles.box + ' ' + (_id === selected && styles.active) },
        empty === 0 && _react2.default.createElement('div', { className: styles.overlay }),
        _react2.default.createElement(
          'div',
          {
            className: styles.card + ' ' + (_id === selected && styles.active),
            onClick: onClick
          },
          _react2.default.createElement(
            'div',
            {
              className: styles.timeBox + ' ' + (freelance ? styles.center : '')
            },
            _react2.default.createElement(
              'div',
              { className: styles.time },
              _support.Helper.toTime(time)
            ),
            !!(percent || discount) && _react2.default.createElement(
              'div',
              { className: styles.promotion },
              this.renderDiscount(percent, discount)
            )
          ),
          !freelance && _react2.default.createElement(
            'div',
            { className: styles.slot },
            empty === 0 ? 'Hết chỗ' : 'C\xF2n ' + empty + ' ch\u1ED7'
          )
        )
      );
    }
  }]);
  return BookingTimeCard;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  onClick: _react.PropTypes.func
}, _temp);
exports.default = BookingTimeCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/BookingTimeCard.js
// module id = 1552
// module chunks = 0